import {
  borderStyle,
  DataGridPremiumProps,
  GRID_AGGREGATION_FUNCTIONS,
  GridRowSpacing,
  StateAwareGridPremium,
  styled,
} from '@sbv-clients/ui-shared';

import { ratio, sumBothAssigned, sumBothNotified } from './aggregators';

const StyledDataGridPremium = styled(StateAwareGridPremium)(({ theme }) => ({
  '--unstable_DataGrid-headWeight': theme.typography.fontWeightRegular,
  '--unstable_DataGrid-overlayBackground': theme.palette.background.paper,
  border: 0,
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    scale: '.996 1',
    transformOrigin: 'left',
  },
  '& .MuiDataGrid-columnHeaders': {
    scale: '.995, 1',
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    border: borderStyle,
  },
  '& .MuiDataGrid-footerContainer': {
    border: 0,
  },
  '& .MuiDataGrid-cell': {
    border: 0,
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .group-row': {
    borderRadius: theme.spacing(2),
  },
  '& .regular-row': {
    border: borderStyle,
    borderRadius: theme.spacing(2),
  },
  '.MuiDataGrid-aggregationColumnHeaderLabel': {
    display: 'none',
  },
}));

const getRowSpacing: DataGridPremiumProps['getRowSpacing'] = (
  params
): GridRowSpacing => ({
  top: (params.id as string).includes('auto-generated') ? 24 : 8,
});

const getRowClassName: DataGridPremiumProps['getRowClassName'] = (params) =>
  (params.id as string).includes('auto-generated')
    ? 'group-row'
    : 'regular-row';

export const noFooterAggregation: DataGridPremiumProps['getAggregationPosition'] =
  (groupNode) => (groupNode == null ? null : 'inline');

const pageSizeOptions = [10, 25, 100];

export const BaseTable = (props: DataGridPremiumProps) => {
  return (
    <StyledDataGridPremium
      name="stats-grid"
      getRowSpacing={getRowSpacing}
      getRowClassName={getRowClassName}
      getAggregationPosition={noFooterAggregation}
      disableRowSelectionOnClick
      columnHeaderHeight={36}
      pagination
      pageSizeOptions={pageSizeOptions}
      disableColumnMenu
      aggregationFunctions={{
        ...GRID_AGGREGATION_FUNCTIONS,
        sumBothNotified,
        sumBothAssigned,
        ratio, // noop,
      }}
      {...props}
    />
  );
};
